import axios from 'axios';
import { getToken } from '../utils/auth';

// Configure axios to use the backend URL
const API_BASE_URL = process.env.REACT_APP_API_URL || `http://${window.location.hostname}:17080`;

axios.defaults.baseURL = API_BASE_URL;
// Send httpOnly cookies with every request
axios.defaults.withCredentials = true;

// Add request interceptor to include auth token from memory (if available)
axios.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    // CSRF protection: custom header prevents cross-origin form submissions
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    // If no in-memory token, the httpOnly cookie handles authentication
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default axios;
